module.exports = __webpack_public_path__ + "images/icons/closed-sign-tilt.svg";